module.exports = __webpack_public_path__ + "img/water-level-new5.753cb879.gif";